import { useEffect } from "react";
import Lenis from "lenis";
import WaterCanvas from "@/components/eden/WaterCanvas";
import ParticlesCanvas from "@/components/eden/ParticlesCanvas";
import FairyDust from "@/components/eden/FairyDust";
import FoliageFrame from "@/components/eden/FoliageFrame";
import Butterflies from "@/components/eden/Butterflies";
import SoundToggle from "@/components/eden/SoundToggle";
import HeroSection from "@/components/eden/HeroSection";
import EditorialMarquee from "@/components/eden/EditorialMarquee";
import ManifestoChapters from "@/components/eden/ManifestoChapters";
import AudioSample from "@/components/eden/AudioSample";
import CountdownTimer from "@/components/eden/CountdownTimer";
import CheckoutSection from "@/components/eden/CheckoutSection";
import EmailSignup from "@/components/eden/EmailSignup";
import AuthorSection from "@/components/eden/AuthorSection";
import EpilogueSection from "@/components/eden/EpilogueSection";
import ReflectionsSection from "@/components/eden/ReflectionsSection";
import LettersSection from "@/components/eden/LettersSection";
import SoundWelcome from "@/components/eden/SoundWelcome";
import TopNav from "@/components/eden/TopNav";
import Footer from "@/components/eden/Footer";

export default function LandingPage() {
    useEffect(() => {
        const lenis = new Lenis({ duration: 1.4, smoothWheel: true });
        let raf;
        const loop = (time) => {
            lenis.raf(time);
            raf = requestAnimationFrame(loop);
        };
        raf = requestAnimationFrame(loop);
        return () => {
            cancelAnimationFrame(raf);
            lenis.destroy();
        };
    }, []);

    return (
        <div data-testid="landing-page" className="relative min-h-screen">
            <div className="light-rays" />
            <WaterCanvas />
            <ParticlesCanvas />
            <FairyDust />
            <FoliageFrame />
            <Butterflies />
            <div className="grain-overlay" />
            <TopNav />
            <main className="relative z-10">
                <HeroSection />
                <EditorialMarquee />
                <ManifestoChapters />
                <AudioSample />
                <CountdownTimer />
                <CheckoutSection />
                <EmailSignup />
                <AuthorSection />
                <EpilogueSection />
                <ReflectionsSection />
                <LettersSection />
            </main>
            <Footer />
            <SoundWelcome />
            <SoundToggle />
        </div>
    );
}
